// const menusList = [{
//     name: 'CRIC2025 AI',
//     iconName: 'home',
//     hover: false,
//     type: 2,
//     list: [{
//         name: 'CRIC2025',
//         type: 1,
//         url: 'https://www.cric.com',
//         titleName: 'CRIC2025',
//         isOpen: false,
//         hover: false,
//         items: []
//       },
//       // {
//       //   name: '企业顾问系统',
//       //   url: 'http://qy.cric.com',
//       //   type: 1,
//       //   titleName: '企业顾问系统',
//       //   isOpen: false,
//       //   hover: false,
//       //   items: []
//       // },

//       {
//         name: '投资决策系统',
//         type: 2,
//         url: 'https://vip.cric.com',
//         titleName: '投资决策系统',
//         isOpen: false,
//         hover: false,
//         items: [{
//             name: '标准版',
//             url: 'https://invest.cric.com/City/City',
//             isSelf: '',
//           },
//           {
//             name: '区域版',
//             url: '',
//             isSelf: 'InvestmentDecision'
//           },
//         ]
//       },
//       {
//         name: '栅格地图',
//         type: 1,
//         url: 'http://grid.cric.com/Home/Index',
//         titleName: '栅格地图',
//         isOpen: false,
//         hover: false,
//         items: []
//       },
//       // {
//       //   name: '栅格地图',
//       //   type: 2,
//       //   url: 'https://vip.cric.com',
//       //   titleName: '栅格地图系统',
//       //   isOpen: false,
//       //   hover: false,
//       //   items: [{
//       //       name: '栅格地图',
//       //       url: 'http://grid.cric.com/Home/Index',
//       //     },
//       //     // {
//       //     //   name: '瑞库智能投排系统',
//       //     //   url: 'http://ruiku.cric.com',
//       //     // }
//       //     // {
//       //     //   name:'城市地图',
//       //     //   url: 'http://grid.cric.com/CityMap/CityMap',
//       //     // },
//       //     // {
//       //     //   name:'热区分析',
//       //     //   url: 'http://grid.cric.com/AreaDiscovery/HotSpots',
//       //     // },
//       //     // {
//       //     //   name:'土地评估',
//       //     //   url: 'http://grid.cric.com/LandAssess/AssessEntry',
//       //     // },
//       //   ]
//       // },
//       {
//         name: 'CRIC应用市场',
//         type: 1,
//         url: 'https://lowcode.cricbigdata.com',
//         titleName: 'CRIC应用市场',
//         isOpen: false,
//         hover: false,
//         items: []
//       },
//       // {
//       //   name: '场景化大屏',
//       //   type: 1,
//       //   url: 'http://dp.cric.com',
//       //   titleName: '场景化大屏',
//       //   isOpen: false,
//       //   hover: false,
//       //   items: []
//       // },
//       // {
//       //   name: '客研系统',
//       //   type: 1,
//       //   url: 'http://gridx.cric.com/jpjc/#/login',
//       //   titleName: '客研系统',
//       //   isOpen: false,
//       //   hover: false,
//       //   items: []
//       // },
//     ]
//   },
//   {
//     name: '不动产运营',
//     iconName: 'mall',
//     hover: false,
//     type: 2,
//     list: [{
//         name: '资产管理系统',
//         url: 'https://asset.caicchina.com/#/index'
//       },
//       {
//         name: '金融数据系统',
//         type: 2,
//         url: '',
//         titleName: '金融数据系统',
//         isOpen: false,
//         hover: false,
//         items: [{
//             name: '投管云',
//             url: 'https://tgy.caicchina.com',
//             isSelf: '',
//           },
//           {
//             name: '市场云',
//             url: 'https://scy.caicchina.com/login',
//             isSelf: ''
//           },
//           {
//             name: '金融数据BI',
//             url: 'https://fbi.caicchina.com/',
//             isSelf: ''
//           },
//         ]
//       },
//       {
//         name: '商办数据系统',
//         url: 'https://db.caicchina.com'
//       },
//       {
//         name: '长租数据系统',
//         url: 'https://newrent.cric.com/',
//       },
//       {
//         name: '文旅数据系统',
//         url: 'https://tourism.cric.com/',
//       },
//       {
//         name: '康养数据系统',
//         url: 'https://ky.cric.com/',
//       },
//       {
//         name: '产城数据系统',
//         url: 'https://cipic.cric.com/',
//       },
//     ]
//   },
//   {
//     name: '物业社区',
//     iconName: 'sell',
//     hover: false,
//     type: 1,
//     list: [{
//       name: '物管数据系统',
//       url: 'https://cpmic.cricbigdata.com',
//     }]
//   },
// ]

const menusList = [
  {
    name: 'CRIC2026 AI',
    hover: false,
    type: 2,
    list: [
      {
        name: '市场顾问',
        url: 'https://www.cric.com',
      },
      {
        name: '土地顾问',
        url: 'https://www.cric.com',
      },
      {
        name: '企业顾问',
        url: 'https://www.cric.com',
      },
      {
        name: 'AI顾问',
        url: 'https://www.cric.com',
      },
    ]
  },
  {
    name: 'DEEP HOUSE',
    hover: false,
    type: 2,
    list: [
      {
        name: '市场云',
        url: 'https://www.deephouseai.com/'
      },
      {
        name: '投管云',
        url: 'https://www.deephouseai.com/'
      },
      {
        name: 'REITs',
        url: 'https://www.deephouseai.com/',
      },
      {
        name: '投资决策系统',
        url: 'https://tzjc.cric.com/',
      },
      {
        name: '商办数据系统',
        url: 'https://sybg.cric.com',
      },
    ]
  },
  {
    name: '长租数据',
    hover: false,
    type: 1,
    list: [{
      name: '长租数据系统',
      url: 'https://rentdata.cric.com',
    }]
  },
  {
    name: '康养数据',
    hover: false,
    type: 1,
    list: [{
      name: '康养数据系统',
      url: 'https://kydata.cric.com',
    }]
  },
]

const imgIconList = {
  'home': require('@assets/img/menus/zhuzhaikaifa.png'),
  'mall': require('@assets/img/menus/budongchan.png'),
  'sell': require('@assets/img/menus/wuyeshequ.png'),
  'homeHover': require('@assets/img/menus/zhuzhaikaifa-blue.png'),
  'mallHover': require('@assets/img/menus/budongchan-blue.png'),
  'sellHover': require('@assets/img/menus/wuyeshequ-blue.png'),
  'stock': require('@assets/img/menus/stock.png'),
  'wy': require('@assets/img/menus/wy.png'),
  'home-active': require('@assets/img/menus/home-active.png'),
  'mall-active': require('@assets/img/menus/mall-active.png'),
  'sell-active': require('@assets/img/menus/sell-active.png'),
  'stock-active': require('@assets/img/menus/stock-active.png'),
  'wy-active': require('@assets/img/menus/wy-active.png'),
}

export {
  menusList,
  imgIconList
}
